import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/index.css";
import { NewFooter } from "../../components/newFooter";
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBInputGroup,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addEmailRecipient } from "../../features/emailCollection/emailCollectionSlice";
import PelvicSenseSectionForIndividualPage from "../../components/PelvicSenseSectionForIndividualPage";

import women from "../../img/individualBannerWomen.png";
import womenCircle from "../../img/womenB.png";
import womenCircle2 from "../../img/womenCircle2.png";
import womenCircle3 from "../../img/womenCircle3.png";
import womencoffe from "../../img/womencoffe.png";
import womenOrange from "../../img/womenOrange.png";
import womanYellowBackground from "../../img/newImageNotPain.png";
import filterOne from "../../img/filter_1.png";
import filterTwo from "../../img/filter_2.png";
import filterThree from "../../img/filter_3.png";
import filterFour from "../../img/filter_4.png";
import keyRi from "../../img/newKeyBoardArrow.png";

import blackDownArrow from '../../img/arrow-black-down.png'

import BBISlim from "../../img/elana-slim-icons/incontinence-slim.png";
import BPSlim from "../../img/elana-slim-icons/bladder-pain-slim.png";
import ConstiSlim from "../../img/elana-slim-icons/constipation-slim.png";
import EndoSlim from "../../img/elana-slim-icons/endometriosis-slim.png";
import MenoSlim from "../../img/elana-slim-icons/menopause-slim.png";
import PSSlim from "../../img/elana-slim-icons/painful-sex-slim.png";
import PelvicProlSlim from "../../img/elana-slim-icons/prolapse-slim.png";
import PostPartSlim from "../../img/elana-slim-icons/postpartum-slim.png";
import ProactiveCareSlim from "../../img/elana-slim-icons/date-slim.png";
import SASlim from "../../img/elana-slim-icons/separated-abs-slim.png";
import VaginoPrepSlim from "../../img/elana-slim-icons/vaginoplasty-slim.png";

import { createUser } from "../../features/user/userSlice";
import "../../styles/newIndividualPage.css";
import IndividualsNeedsSection from "../../components/IndividualsNeedsSection";

export function Individual() {
  const [button1, setButton1] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [userData, setUserData] = useState({});
  const [showOptions, setShowOptions] = useState(false);

  const sliderLeft = () => {
    let slice = document.querySelector("#slider");
    console.log("scrollLeft", slice);
    slice.scrollLeft = slice.scrollLeft - 500;
  };

  const sliderRight = () => {
    let slice = document.querySelector("#slider");
    console.log("scrollLeft", slice);
    slice.scrollLeft = slice.scrollLeft + 500;
  };

  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  //and here end the carousel
  const dispatch = useDispatch();

  const addEmailToNewsletterList = (email) => {
    dispatch(addEmailRecipient({ email: email, type: "Newsletter" }));
    setNewsletterEmail("");
  };

  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  console.log(userData);

  const navigation = useNavigate();

  return (
    <div className="">
      {/* /////////////////////////////first banner///////////////////////// */}
      <div
        className={
          windowDimensions.width <= 692
            ? "bgindividualpageMobile"
            : "bgindividualpage "
        }
      >
        <div className="padding-letters center-mobile-text">
          <h1 className="margin-text-home  title-home-individual mt-5">
            Pelvic Care, <br className="no-pc" />
            Your Way
          </h1>
          <p className="margin-text-home-small  text-individual-home-original text-dark ">
            Elana believes you should be the one to take control of managing
            your
            <br className="mobile-view-hidden"/> pelvic health, where, how and when it suits you.
          </p>
          <div class="input-wrapper">
            <label for="first" className="label-individual text-dm">
              I’d Like To:
            </label>
            <button
              type="text"
              className="select-individual "
              onClick={() => setShowOptions(!showOptions)}
            >
              <div className="d-flex justify-content-start">
                <p className="text-dm m-0 ms-2 text-black">Start a Healing Program</p>
                <p className="m-0 ms-auto me-2"><img src={blackDownArrow} className="black-down-arrow"/></p>
              </div>
            </button>
            {showOptions && (
              <div className="bg-dropdown">
                  <a  href="#PelvicSenseSectionForIndividualPage"
                    className="text-decoration-none link-color">
                <p className="text-dm p-hover m-0 p-3 text-start">
                   
                  
                    Start a Healing Program
                </p>
                  </a>
                  <Link
                    to="/sharePelvicCareStory"
                    className="text-decoration-none link-color "
                  >
                <p className="text-dm p-hover m-0 p-3 text-start">
                    Share my Pelvic Care Story
                </p>
                  </Link>
                  <Link
                    to="/pelvicCareQuestion"
                    className="text-decoration-none link-color "
                  >
                <p className="text-dm p-hover m-0 p-3 text-start">
                    Ask a Pelvic Care Question
                </p>
                  </Link>
                {/* <p className="text-dm p-hover m-0 p-3 text-start">
                  {" "}
                  <Link
                    to="/employer"
                    className="text-decoration-none link-color"
                  >
                    Ask my Employer to Offer Elana
                  </Link>
                </p> */}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ////modal  */}
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle></MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <h1 className="text-center text-al">Sign up for the waitlist</h1>
              <div className="d-grid justify-content-center">
                <div className="d-grid">
                  <label>First Name</label>
                  <input
                    className="input-modal-individual"
                    type="text"
                    name="firstName"
                    value={userData?.firstName}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="d-grid">
                  <label>Last Name</label>
                  <input
                    className="input-modal-individual"
                    type="text"
                    name="lastName"
                    value={userData?.lastName}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="d-grid">
                  <label>Email Address</label>
                  <input
                    className="input-modal-individual"
                    type="text"
                    name="email"
                    value={userData?.email}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="d-grid">
                  <label>
                    Choose Password
                    <span className="smallLetters"> (9 characters)</span>
                  </label>
                  <input
                    className="input-modal-individual"
                    type="password"
                    name="password"
                    value={userData?.password}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div>
                <p className="text-break text-modal-individual">
                  I consent to Elana processing in the U.S. all data I provide
                  through this app, including sensitive data such as health
                  information, so that Elana can provide services to me. In
                  addition, by clicking Sign Up, I acknowledge that I have read
                  and agree to Elana’s Privacy Policy and Terms and Conditions.
                  I agree to receive emails and updates from Elana.
                </p>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="button-modal m-auto"
                  onClick={() => {
                    dispatch(createUser(userData));
                    setUserData({});
                  }}
                >
                  SIGN UP
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
  {/* ////////////////3 circles///////////////////// */}
      <div className="BannerTwo banner-padding">
        <div className="" order="1">
          {/* <h1 className="text-center titleBannerTwo px-2">
            Whether you’re currently experiencing pelvic issues or want
            <br className="no-phone" /> to prevent future ones, Elana is here
            for you.
          </h1>
          <p className="text-center pb-5 text-banner-two no-phone">
            Yes, that’s right - it’s not taboo here! Elana is YOUR pelvic care
            partner.
          </p> */}
          <h1 className="text-center titleBannerTwo-bg px-2 mx-auto"><span className="purple-bg-for-titleBannerTwo text-black">Pelvic Health Dysfunction among women</span></h1>
        </div>
        <div className="mt-5">
          <MDBRow className="d-flex margin-circles-women">
            <MDBCol size="12" md="4" className="">
              <div className=" d-flex justify-content-center separation-card-two">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={womenCircle3} className="m-auto"></img>
                  </div>
                  <p className="text-center px-5 pt-3 text-dm">
                    For the woman who is in perimenopause is experiencing pelvic
                    weakness and dryness.{" "}
                  </p>
                </div>
              </div>
            </MDBCol>
            <MDBCol size="12" md="4" className="border-purple-individual">
              <div className=" d-flex justify-content-center separation-card-two">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={womenCircle} className="m-auto"></img>
                  </div>
                  <p className="text-center px-5 pt-3 text-dm">
                    For the woman who had a child and now pees when she laughs,
                    jumps, or simply cannot hold it.
                  </p>
                </div>
              </div>
            </MDBCol>
            <MDBCol size="12" md="4" className="">
              <div className=" d-flex justify-content-center separation-cards">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={womenCircle2} className="m-auto"></img>
                  </div>
                  <p className="text-center px-5 pt-3 text-dm">
                    For the woman who suffers from painful sex despite her
                    deepest desires to enjoy the moment.
                  </p>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
       {/* ////////////////banner image and text blue bg ///////////////////// */}

      <IndividualsNeedsSection width={windowDimensions.width} />

      {/* <div className="">
        <MDBRow around className="margin-separation">
          <MDBCol
            size="12"
            md="6"
            order={windowDimensions.width <= 760 ? "2" : "1"}
          >
            <img src={women} className="img-fluid" />
          </MDBCol>
          <MDBCol
            size="12"
            md="6"
            order={windowDimensions.width <= 760 ? "1" : "2"}
          >
            <div className="controller-list">
              <h1 className="title-banner-2">
                Help for healing now, and <br className="no-phone" /> preventing
                issues in the future
              </h1>
              <p className="mt-4 text-individual-home spacing">
                Elana brings you a team of pelvic care specialists, education,
                <br className="brake-1285" /> and products, whenever and
                wherever works for you.
              </p>
              <ul className="p-0 mt-5 text-individual-home-two"> 
              <p className="m-0 mt-2 center-p ">Pelvic Floor Training</p>
              <p className="m-0 mt-2 center-p">Postpartum Care</p>
              <p className="m-0 mt-2 center-p">Perimenopause</p>
              <p className="m-0 mt-2 center-p">Leaky Bladder/Bowels</p>
              <p className="m-0 mt-2 center-p">Painful Sex</p>
              <p className="m-0 mt-2 center-p">
                <Link to="/browse" className="text-decoration-none">
                  <p className="text-hover">and more...</p>
                </Link>
              </p>
               </ul> 
            </div>
          </MDBCol>
        </MDBRow>
      </div> */}

      {/* //the ul need to be coment if we gonna use this piece of code */}

      {/* ////////////////////////////carrousel//////////////////////////////////////////////////// */}
     <div className="banner-padding">
      <div className="category-cards">
      <h1 className="text-center text-al fs-48-32">Pelvic Conditions that Elana supports</h1>
      <p className='text-center text-dm text-carrousel'>We are on the move to bring you a team of pelvic care specialists and <br/> resources for many kinds of pelvic health issues.</p>
        <div className="carousel" id="slider">
          <div className="inner-carousel">
            <Link className="link-categories" to="/practitionerListing/0">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Bladder & Bowel Incontinence
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={BBISlim} />
                </div>
              </div>
            </Link>
            <Link
              className="link-categories d-flex justify-content-center"
              to="/practitionerListing/1"
            >
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Bladder Pain
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={BPSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/2">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Constipation
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={ConstiSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/3">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Endometriosis
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={EndoSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/4">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Menopause & Perimenopause
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={MenoSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/5">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Painful Sex
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={PSSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/6">
              <div className="item mx-5 pb-2 pt-2">
                <h6 className="text-center text-al mt-3 text-black fs-24">
                  Pelvic Organ Prolapse
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={PelvicProlSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/7">
              <div className="item mx-5 pb-2 pt-2">
                <h6 className="text-center text-al mt-3 text-black fs-24">
                  Postpartum Recovery
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={PostPartSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/8">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Proactive Pelvic Care
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={ProactiveCareSlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/9">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Separated Abs
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={SASlim} />
                </div>
              </div>
            </Link>
            <Link className="link-categories" to="/practitionerListing/10">
              <div className="item mx-5 pb-2 pt-3">
                <h6 className="text-center text-al mt-2 text-black fs-24">
                  Vaginoplasty Prep & Recovery
                </h6>
                <div className="d-flex justify-content-center mt-3">
                  <img src={VaginoPrepSlim} />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      </div>

      {/* BRANDON YOU CAN WORK HERE */}
      <PelvicSenseSectionForIndividualPage id='PelvicSenseSectionForIndividualPage'/>


      {/* //////////////circles//////////////////// */}
      {/* <div className="bg-circle">
        <div className="pt-4 pt-5">
          <h1 className="text-center mt-5 title-home-individual-two">
            Elana’s Personalized Approach to Care
          </h1>
          <h6 className="text-center text-coming-soon">Coming soon</h6>
        </div>
        <div className="center-cricles">
          <div>
            <MDBContainer>
              <MDBRow className="center-mobile">
                <MDBCol
                  size={windowDimensions.width <= 1000 ? "12" : ""}
                  className="d-flex justify-content-center mb-4"
                >
                  <div className="circle-indivudial-two">
                    <h6 className="text-dm">
                      Track your
                      <br /> Symptoms
                    </h6>
                  </div>
                </MDBCol>
                <MDBCol
                  size={windowDimensions.width <= 1000 ? "12" : ""}
                  className="d-flex justify-content-center mb-4"
                >
                  <div className="circle-indivudial-two">
                    <h6 className="text-dm">
                      Shopping for
                      <br /> Pelvic Health
                    </h6>
                  </div>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center mb-4">
                  <div className="circle-indivudial-two">
                    <h6 className="text-dm">
                      Telehealth <br />
                      Services
                    </h6>
                  </div>
                </MDBCol>
                <MDBCol
                  size={windowDimensions.width <= 1000 ? "12" : ""}
                  className="d-flex justify-content-center mb-4"
                >
                  <div className="circle-indivudial-two">
                    <h6 className="text-dm">
                      Community <br />
                      Content
                    </h6>
                  </div>
                </MDBCol>
                <MDBCol
                  size={windowDimensions.width <= 1000 ? "12" : ""}
                  className="d-flex justify-content-center mb-4"
                >
                  <div className="circle-indivudial-two no-phone">
                    <h6 className="text-dm">
                      Educational
                      <br /> Resources
                    </h6>
                  </div>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-0 pb-5 p-3">
          <button
            onClick={toggleShow}
            className="buttonEmail blue-hover whitespace"
          >
            SIGN UP FOR THE WAITLIST
          </button>
        </div>
      </div> */}

      {/* ////////////////banner 4///////////////////// */}
      <div className="bg-banner-4 margin-row-controller container">
        <div className="text-controller-4 m-4 ">
          <div>
            <h1 className="text-separation title-home-individual-two">
              Check Out our Blogs on Pelvic Health
            </h1>
            <p className="text-separation text-individual-home">
              Discover pelvic care with Elana
            </p>
          </div>
          <div className="align-text">
            <span className="text-separation">
              <a
                href="https://www.myelana.com/blog"
                target="_blank"
                className="text-decoration-none text-hover"
              >
                Read All
              </a>
              <span>
                <img src={keyRi} className="ms-2 text-hover arrow-icon-all" />
              </span>
            </span>
          </div>
        </div>

        <div className="circlesController ">
          <div className="padding-row-controller blog-mobile-hidden">
            <MDBRow className="row-controller">
              <MDBCol className="margin-cards blog-card-width" size="4">
                <img src={womencoffe} className="card-blog-images"></img>
                <p className="text-break separation-mobile fs-20-14 mt-2 text-dm">
                  Perimenopause: What it is and why it's not all bad.{" "}
                </p>
                <a
                  href="https://www.myelana.com/post/perimenopause-what-it-s-all-about-and-why-it-s-not-all-bad"
                  target="_blank"
                >
                  <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-decoration-none text-white">
                    {" "}
                    READ MORE
                  </button>
                </a>
              </MDBCol>
              <MDBCol className="margin-cards blog-card-width" size="4">
                <img src={womenOrange} className="card-blog-images"></img>
                <p className="text-break separation-mobile fs-20-14 mt-2 text-dm">
                  What is Pelvic Health? And where to find answers.
                </p>
                <a
                  href="https://www.myelana.com/post/what-is-pelvic-health"
                  target="_blank"
                >
                  <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-decoration-none text-white">
                    {" "}
                    READ MORE
                  </button>
                </a>
              </MDBCol>
              <MDBCol className="margin-cards blog-card-width" size="4">
                <img
                  src={womanYellowBackground}
                  className="card-blog-images"
                ></img>
                <p className="separation-mobile fs-20-14 mt-2 text-dm">
                  It’s time to talk. Ending the taboo of pelvic health.
                </p>
                <a
                  target="_blank"
                  href="https://www.myelana.com/post/what-prevents-you-from-getting-help"
                >
                  <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-decoration-none text-white">
                    {" "}
                    READ MORE
                  </button>
                </a>
              </MDBCol>
            </MDBRow>
          </div>
          <div className="padding-row-controller blog-desktop-hidden">
            <MDBRow className="row-controller">
              <MDBCol>
                <a
                  className="link blue-hover"
                  href="https://www.myelana.com/post/perimenopause-what-it-s-all-about-and-why-it-s-not-all-bad"
                  target="_blank"
                >
                  <div className="margin-cards">
                    <img src={womencoffe} className="card-blog-images"></img>
                    <p className="text-break separation-mobile fs-24-18-14 mt-2 text-dm text-black">
                      Perimenopause: What it is and why it's not all bad.{" "}
                    </p>
                    <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                      READ MORE
                    </button>
                  </div>
                </a>
              </MDBCol>
              <MDBCol>
                <a
                  className="link blue-hover"
                  href="https://www.myelana.com/post/what-is-pelvic-health"
                  target="_blank"
                >
                  <div className="margin-cards">
                    <img src={womenOrange} className="card-blog-images"></img>
                    <p className="text-break separation-mobile fs-24-18-14 mt-2 text-dm text-black">
                      What is Pelvic Health? And where to find answers.
                    </p>
                    <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                      READ MORE
                    </button>
                  </div>
                </a>
              </MDBCol>
              <MDBCol>
                <a
                  className="link blue-hover"
                  href="https://www.myelana.com/post/what-prevents-you-from-getting-help"
                  target="_blank"
                >
                  <div className="margin-cards">
                    <img
                      src={womanYellowBackground}
                      className="card-blog-images"
                    ></img>
                    <p className="separation-mobile fs-24-18-14 mt-2 text-dm text-black">
                      It’s time to talk. Ending the taboo of pelvic health.
                    </p>
                    <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                      READ MORE
                    </button>
                  </div>
                </a>
              </MDBCol>
            </MDBRow>
          </div>
        </div>
      </div>

      {/* <div className="position-relative gradientTry">
      <div className="position-absolute bottom-0 start-50 translate-middle-x bubblesTry">

      </div>

      </div> */}

      <div
        className={
          windowDimensions.width <= 692
            ? "bg-gradient-purple-mobile"
            : "bg-gradient-purple"
        }
      >
        <div className="text-center text-controller  pt-5 mb-5">
          <h1 className="title-home-individual-three mt-4">
            What you can do with Elana
          </h1>
          <p className="text-coming-soon text-gray fs-20-16">
            {" "}
            Options for your pelvic health journey.
          </p>
        </div>
        <div className="">
          <div className="container">
            <div className="icon-controller row">
              <div className="col-12 col-lg-4 col-md-6">
                <div className="numbers-image">
                  <img src={filterOne} className="space-b" />
                </div>
                <div className="numbers-text">
                  <p className="mt-3 text-dm fs-20-16">
                    Start a healing
                    <br />  program
                  </p>
                  <a href="#PelvicSenseSectionForIndividualPage" className="text-decoration-none">
                    <span className="go">
                    Start{" "}
                      <img src={keyRi} className="arrow-icon" />
                    </span>
                    </a>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-6 margin-top-mobile numbers-border-top numbers-border-bottom">
                <div className="numbers-image">
                  <img src={filterTwo} className="space-b" />
                </div>
                <div className="numbers-text">
                  <p className="mt-3 text-dm fs-20-16">
                    Ask a pelvic
                    <br /> care question
                  </p>
                  <Link
                    to="/pelvicCareQuestion"
                    className="text-decoration-none"
                  >
                    <span className="go">
                    Ask{" "}
                      <img src={keyRi} className="arrow-icon" />
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-6 margin-top-mobile ">
                <div className="numbers-image">
                  <img src={filterThree} className="space-b" />
                </div>
                <div className="numbers-text">
                  <p className="mt-3 text-dm fs-20-16">
                    Share my pelvic <br />
                    care story
                  </p>
                  <Link
                    to="/sharePelvicCareStory"
                    className="text-decoration-none"
                  >
                    <span className="go">
                    Share{" "}
                      <img src={keyRi} className="arrow-icon" />
                    </span>
                  </Link>
                </div>
              </div>
              {/* <div className="col-12 col-lg-4 col-md-6 margin-top-mobile numbers-border-bottom">
                <div className="numbers-image">
                  <img src={filterFour} className="space-b" />
                </div>
                <div className="numbers-text">
                  <p className="mt-3 text-dm fs-24-16">
                    Ask my employer <br /> to offer Elana
                  </p>
                  <Link to="/employer" className="text-decoration-none">
                    <span>
                      Go
                      <img src={keyRi} className="arrow-icon" />
                    </span>
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="direction">
          <h1 className="title-home-individual-two">
            We’ll only send you the important stuff.
          </h1>
          <div className="email-banner  align-items-end ">
            <div className="d-flex align-items-end">
              <p className="m-0 text-individual-home">
                Sign up to get updates from Elana and the latest on
                <br className="no-phone" /> pelvic care delivered right to your
                inbox.
              </p>
            </div>
            <div className="input-separation">
              <div className="">
                <div className="d-flex">
                  <MDBInputGroup className="input-email mt-3">
                    <input
                      className="text-dm text-spacing-minus-1 form-control p-2"
                      placeholder="Enter your email"
                      type="text"
                      value={newsletterEmail}
                      onChange={(e) => {
                        setNewsletterEmail(e.target.value);
                      }}
                    />
                    {windowDimensions.width > 500 ? (
                      <button
                        onClick={() =>
                          addEmailToNewsletterList(newsletterEmail)
                        }
                        className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover text-dm"
                      >
                        STAY IN THE KNOW
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          addEmailToNewsletterList(newsletterEmail)
                        }
                        className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover px-4 text-dm"
                      >
                        JOIN
                      </button>
                    )}
                  </MDBInputGroup>
                </div>
              </div>
            </div>
          </div>
          <p className="mt-3 fs-12-10 text-dm text-gray">
            Disclaimer: The information provided through Elana Health{" "}
            <br className="display-320" /> website and services is not intended
            or implied to be <br className="display-320" /> a substitute for
            professional
            <br className="display-390" /> medical advice, diagnosis or
            treatment.
          </p>
        </div>
        {/* <div className="individual-cta-bottom">
            <h1 className="text-al text-black fs-48-28 mx-2">
              We’ll only send you the important stuff.
            </h1>
            <MDBRow>
              <MDBCol sm="12" md="6" className="d-flex ">
                <p className="m-0 text-dm text-gray fs-24-18 mx-2">
                  Sign up to get updates from Elana and the latest on
                   pelvic care delivered right to your inbox.
                </p>
              </MDBCol>
              <MDBCol sm="12" md="6" className="d-flex justify-content-center align-items-center">
                <MDBInputGroup className="newsletter-input-width border-radius-8 text-dm input-individual-cta">
                  <input
                    className="text-dm text-spacing-minus-1 border-radius-8 form-control update-input-padding"
                    placeholder="Enter your email"
                    type="text"
                    value={newsletterEmail}
                    onChange={(e) => {
                      setNewsletterEmail(e.target.value);
                    }}
                  />
                  <button
                    onClick={() => addEmailToNewsletterList(newsletterEmail)}
                    className="brand-bg-purple py-2 px-4 border-0 text-white blue-hover text-dm border-radius-end-8"
                  >
                    {windowDimensions.width > 450 ? "STAY IN THE KNOW": "JOIN"}
                  </button>
                </MDBInputGroup>
              </MDBCol>
            </MDBRow>
              <p className="margin-individual-disclaimer text-dm py-3 px-2 fs-14 text-gray">
                Disclaimer: The information provided through Elana Health
                website and services is not intended or implied to be a
                substitute for professional medical advice, diagnosis or
                treatment.
              </p>
          </div> */}
      </div>
      <NewFooter />
    </div>
  );
}
